import { useSnapshot } from 'valtio'
import React, { type ReactElement, useEffect } from 'react'
import cn from 'classnames'
import { recurringPaymentProxy } from '../../../../../shared/proxies/recurringPaymentProxy'
import { PlaceholderBox } from '../../../../../shared/components/ui/PlaceholderBox'
import { ErrorBox } from '../../../../../shared/components/ui/ErrorBox'
import { executeRpOccurrenceSearch } from '../executeRpOccurrenceSearch'
import RpOccurrenceRedTooltipIcon
  from '../../../../../shared/components/ui/tooltips/rpOccurrencesListIcon/RpOccurrenceRedTooltipIcon'
import { RoOccurrencesRows } from './RoOccurrencesRows'
import { RpOccurrencesTableHeader } from './RpOccurrencesTableHeader'
import { FutureOccurrencesRows } from './FutureOccurrencesRows'
import { RpOccurrencesTableFooter } from './RpOccurrencesTableFooter'

export function RpOccurrencesTable (): ReactElement | null {
  const { relatedApiCall, recurringPayment } = useSnapshot(recurringPaymentProxy)
  const id = recurringPayment?.id as string

  useEffect(() => {
    if (!id) { return }
    void executeRpOccurrenceSearch(id)
  }, [recurringPayment?.id, id])

  return (
    <PlaceholderBox loading={relatedApiCall.loading} rows={40} rowHeight="h-5">
      <ErrorBox error={relatedApiCall.error}>
        <div className={cn('flex flex-row shadow rounded p-4')}>
          <h2 className="text-black text-xl text-left">
            Occurrences
          </h2>
        </div>
        <table className="w-full">
          <thead className="text-left">
            <tr>
              <RpOccurrencesTableHeader title="Date" width={20} />
              <RpOccurrencesTableHeader title="Original Amount" width={20} />
              <RpOccurrencesTableHeader title="Collected Amount" width={20} />
              <RpOccurrencesTableHeader title="Status" width={20} />
              <RpOccurrencesTableHeader title="Action" width={20} />

            </tr>
          </thead>

          <tbody>
            <tr>
              <td colSpan={5} className={cn('border-t border-b border-gray-300 bg-gray-200 p-3 font-semibold')}>
                Upcoming Occurrences
              </td>
            </tr>
          </tbody>
          <tbody>
            <FutureOccurrencesRows />
          </tbody>
          <tbody>
            <tr>
              <td colSpan={5} className={cn('border-t border-b border-gray-300 bg-gray-200 p-3 font-semibold')}>
                <div className="flex flex-row w-full">
                  <RpOccurrenceRedTooltipIcon errorCount={recurringPayment?.failedCount ?? ''} />

                </div>
              </td>
            </tr>
          </tbody>
          <tbody>
            <RoOccurrencesRows />
          </tbody>
        </table>
        <RpOccurrencesTableFooter />
      </ErrorBox>
    </PlaceholderBox>
  )
}
